<style lang="scss" scoped>
.notRelease{
    color:#ff0000;
}
.feedbackModify{
    color:#fdc989;
}
.feedbackPass{
    color:#99e6c8;
}
.el-range-editor.el-input__inner{
    width: 100%;
    border: 0px solid #dcdfe6;
}
.timeIsEdit{
    color:#507dac;
}
.noTimeIsEdit{
    color:#323232
}
.but-fill-time{
    position: absolute;
    top: 18px;
    right: 0px;
}
.but-fill-time img{
    width: 20px;
    height: 20px;
}
</style>

<template>
   <!--  -->
    <u-table-column
        :prop="col.prop"
        :label="col.label"
        align="center"
        v-if="!col.show"
        :fixed="col.fixed"
        :min-width="width"
        :sortable="col.sortable"
		:render-header="col.renderHeader"
		:sort-method="col.sortMethod"
        :show-overflow-tooltip="editField.indexOf(col.prop) == -1"
        >
        <template slot="header" slot-scope="slot" >
            <span :data-id="slot.$index" v-if="editField.indexOf(col.prop) != -1 && !col.isbitian">
                <span style="color:#ff0101">*</span>
                {{col.label}}
            </span>
            <span v-else>{{col.label}}</span>
        </template>
        <!-- :render-header="renderHeader" -->
        <template slot-scope="scope" >
            <!-- !isAdmin非管理员界面 -->
            <!-- {{console.log(scope)}} -->
            <!--销量只能输入整数------->
            <!-- <el-input @paste.native="onPaste(scope.$index,col.prop)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && !isNoEditRow && !col.noNeedControl && !col.isData" type="number"  @keydown.native="channelInputLimit($event,scope.row,col.prop,col)"  @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)"  v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"   placeholder="请输入" size="small"  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"/> -->
            <el-input type="text" @paste.native="onPaste(scope.$index,col.prop)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && !isNoEditRow && !col.noNeedControl && !col.isData"  @keydown.native="channelInputLimit($event,scope.row,col.prop,col,scope.$index)" 
             @focus='getfocus(scope.row,col.prop,$event,col,scope.$index)' @blur="dblur($event)"  v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope,scope.$index)" placeholder="请输入" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;"/>
            
            <!-- 填写中文 -->
            <el-input  v-if="editField.indexOf(col.prop) != -1 && !isAdmin && !isNoEditRow && col.noNeedControl && !col.isData" @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)"  v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"   placeholder="请输入" size="small" />
            <!-- 选择日期 -->
            <el-date-picker @paste.native="onPaste(scope.$index,col.prop)" v-if="editField.indexOf(col.prop) != -1 && col.isData"
            @focus='getfocus($event,col,scope.$index,true)' @blur="dblur($event,true)"
                v-model="scope.row[col.prop]"
                style="width: 100%"
                type="date"
                value-format="timestamp"
                :picker-options="scope.row.pickerOptions"
                placeholder="请选择"
                prefix-icon="return fasle">
                <!-- :editable="false" -->
            </el-date-picker>
            
            <span v-if="editField.indexOf(col.prop) == -1  && !isAdmin && !isNoEditRow"> {{strGetVal(col.prop,scope)}}</span>

            <!--  非管理员界面 且 具有行属性-->
            <el-input type="number" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && isNoEditRow &&unEditRow.indexOf(scope.$index)== -1 && !scope.row.isFuShu"  @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" placeholder="请输入" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;"/>

            <!--  非管理员界面 且 具有行属性--负数-->
            <el-input type="text"  v-if="editField.indexOf(col.prop) != -1 && !isAdmin && isNoEditRow &&unEditRow.indexOf(scope.$index)== -1 && scope.row.isFuShu"  @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" placeholder="请输入" size="small" oninput="value=value.replace(/[^\d\.-]/, '').replace(/^0(?=[0-9])/, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/\.{2,}/g, '.').replace(/[^-\d.]/g, '') "/>

            <span v-if="editField.indexOf(col.prop) == -1 && !isAdmin && isNoEditRow && unEditRow.indexOf(scope.$index)== -1"> {{strGetVal(col.prop,scope)}}</span>
            <span v-if="!isAdmin && isNoEditRow && unEditRow.indexOf(scope.$index)!= -1"> {{strGetVal(col.prop,scope)}}</span>
            
            
            <!-- 管理员界面 -->
           <div class="timeIsEdit" v-if="editField.indexOf(col.prop) != -1 && isAdmin && scope.row.completeFlag !=2" @click="chooseTime(scope.$index, scope.row,col.prop)" > 
                {{parseInt(scope.row.beginFillDate) | dateformat('YYYY.MM.DD')}}
                -{{parseInt(scope.row.endFillDate) | dateformat('YYYY.MM.DD')}} 
                <div class="but-fill-time"><img class="bm bm-img" src="@/asserts/img/btn_Fill.png"/></div>
            </div>
            <div class="noTimeIsEdit"  v-if="editField.indexOf(col.prop) != -1 && isAdmin && scope.row.completeFlag ==2" > 
                {{parseInt(scope.row.beginFillDate) | dateformat('YYYY.MM.DD')}}
                -{{parseInt(scope.row.endFillDate) | dateformat('YYYY.MM.DD')}} </div>

            <!-- 管理员界面 发布未发布 -->
            <span v-if="completeFlagObj && completeFlagObj.name.indexOf(scope.column.property) != -1  && isAdmin"> 
                <!-- <div :class="strGetVal(col.prop,scope)==2?'':'notRelease'">{{strGetVal(col.prop,scope)==0?'未填报':strGetVal(col.prop,scope)==1?'未发布':'已发布'}}</div> -->

				<!-- v2.0   未发布，已发布，已反馈通过，已反馈修改 -->
                <div :class="scope.row.dataStatus == '未发布' ? 'notRelease': scope.row.dataStatus == '已反馈通过' ? 'feedbackPass': scope.row.dataStatus == '已反馈修改' ? 'feedbackModify': ''">{{scope.row.dataStatus}}</div>
            </span>

            <span v-if="completeFlagObj && completeFlagObj.name.indexOf(scope.column.property) == -1 && editField.indexOf(col.prop) == -1  && isAdmin"> {{strGetVal(col.prop,scope)}}</span>
        </template>
        <template v-if="col.children && !col.show">
            <digital-pl-column
                v-for="(item, index) in col.children"
                :key="index"
                :col="item"
                :unEditRow="unEditRow"
                :editField="editField"
                :pasteField="pasteField"
                :height="height" 
                :formatterList="formatterList"
                :tableData="tableData"
                @modification="modificationa"
				@loseFocus="loseFocus"
                @pasteData="pasteData"
                :width="item.width">
            </digital-pl-column>
        </template>
    </u-table-column>
</template>
<script>
export default {
    name: "digital-pl-column",
    data() {
        return {
            createTime:"",
            sth:"",
            field:[],
            tempkey:"",
            fuShu: false,
            fushuNumber: "",
            currentCol:"",
            currentIndex:"",
            tLength:"",//table长度
            focusIndex:"",//聚焦在哪一行
            focusProp:"",
            pasteFlag:false
        };
    },
    props: {
        isNoEditRow:{
            type:Boolean
        },
        isAdmin:{
            type:Boolean
        },
        tableData:{
            type: Array
		},
        col: {
            type: Object
        },
        completeFlagObj:{
            type: Object
        },
        editField:{
            type: Array
        },
        pasteField:{
            type: Array,
            default: () => {
                return []
            }
        },
        unEditRow:{
            type: Array
        },
        formatterList:{
            type: Array
		},
		height:{
			type: String
		},
		formatteColumn:{
			type: Object
        },
        width:{
			type: String
		},
		maxLength:{
			type: Number,
			default: function(){
				return 17
			}
		},
    },
    methods: {
          substrClipTest(clipText,data){
            let index = clipText.indexOf("\r\n");
            if(index > -1){
                let rowResult = clipText.slice(0,index).split("\t");
                data.push(rowResult);
                let text = clipText.slice(index+2);
                if(text.indexOf("\r\n") > -1){
                     this.substrClipTest(text,data);
                }
                return data;
            }
        },
        onPaste(index,prop){
            this.pasteFlag=true;
            //如果不满足 黏贴列表传空pasteField=[]
            if(this.pasteField&&this.pasteField.length>0){
                navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText)
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        let editData = []; 
                        //2.结果集处理成对象 类型，字段名，内容
                        result.forEach((value,key)=>{
                            let data = [];
                            let startVal =false,i=0;
                            this.pasteField.forEach((editValue,editKey)=>{
                                if((editValue.name == prop || startVal)&&value[i]!=undefined){//2个字段相等就开始， 直到数组遍历完
                                    startVal =true;
                                    let obj={type:editValue.type,key:editValue.name,value:value[i],isCover:editValue.isCover};
                                    data.push(obj);
                                    i++;
                                }
                            });
                            editData.push(data);
                        });
                        console.log("结果集",editData)
                        this.tLength=this.tableData.length
                        //3.结果集 写入到表里面
                        editData.forEach((value,key)=>{
                            value.forEach((innerValue,innerKey)=>{
                                if(index+key<this.tLength){
                                    //每种类型的处理
                                    if(innerValue.isCover){
                                        if(innerValue.type == "number"){
                                            this.tableData[index+key][innerValue.key] = parseFloat(innerValue.value);
                                        }else if(innerValue.type == "date"){
                                            this.tableData[index+key][innerValue.key] = moment(innerValue.value).valueOf();
                                        }else{
                                            this.tableData[index+key][innerValue.key] = innerValue.value;
                                        }
                                    }
                                }
								
                            });
                        });
                        //公共处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }else{
                 navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText)
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        //自己处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }
        },
        pasteData(e){
            this.$emit("pasteData",e);
        },
        chooseTime(index,row,prop){
            this.$emit("openDialog",{index:index,row:row,prop:prop});
        },
        //失去焦点
		loseFocus(e){
			this.$emit("loseFocus", this.tableData);
		},
		//input 监听
		modificationa(e){
			this.$emit("modification",e);
        },
        //键盘监控
        getFocusKeydown(e){
            let that = this;
            $(e.target).keydown(function(e) {
                if (e.ctrlKey && (e.keyCode == 86)){
                    console.log(that.currentCol,"Document catch Ctrl+V")
                    that.pasteFlag=true;
                    that.onPaste(that.currentIndex,that.currentCol);
                } 
                
            });
        },
        //获取到焦点
        getfocus(row,prop,e,col,index,x){
            console.log(row,prop,e,col,index,x,"===>>>> 获取到焦点")
            this.pasteFlag = false;
            let rowprop = eval('row.'+prop );
            e.target.type="number";
            this.focusIndex = index;
            this.focusProp = col.prop;
            this.currentCol =col.prop;
            this.currentIndex =index;
            this.getFocusKeydown(e);
            if(x){
                e.$el.children[0].className = 'get-focus el-input__inner';
            }else{
                e.target.className = 'get-focus el-input__inner';
            }
            this.$nextTick(()=>{
                setTimeout(()=>{
                    e.target.type="text";
                    if(rowprop){
                        e.target.value = this.delcommafy(rowprop);
                    }
                    e.target.selectionStart = e.target.value.length;
                },30);
            });
            
        },
        //失去焦点
        dblur(e,x){
            e.target.type="text";
            e.target.value = this.commafy(e.target.value);
            if(x){
                e.$el.children[0].className = 'el-input__inner';
            }else{
                e.target.className = 'el-input__inner';
            }
            this.$emit("loseFocus", this.tableData);
        },
        // 圆角问题
        inputQue(key,rowprop,selectionStart,e,index1,row,prop){
            //光标问题
            let eselectionStart = e.target.selectionStart;
            let eselectionEnd = e.target.selectionEnd;
                setTimeout(() => {
                    let position=selectionStart;
                    if(key != "Backspace"){
                        position = selectionStart+1;
                    }else{
                        
                        if(eselectionEnd - eselectionStart != 0){
                            position = e.target.selectionStart;
                        }
                    }
                e.target.selectionStart =position;
                e.target.selectionEnd =position;
            }, 10);
            let code =e.code.replace(/[^0-9]/ig,"");
            if(key === '.'){
                code=".";
            }
            let word="";
            if(key === "Backspace"){
                if(e.target.selectionEnd - e.target.selectionStart == 0){
                     word = (rowprop+"").slice(0, selectionStart) + (rowprop+"").slice(selectionStart+1);
                }else{
                     word = (rowprop+"").slice(0, e.target.selectionStart) + (rowprop+"").slice(e.target.selectionEnd);
                }
               
            }else{
                word = (rowprop+"").slice(0, selectionStart) + code + (rowprop+"").slice(selectionStart);
            }
            this.inputFunc(index1,row,prop,word);

        },
        channelInputLimit(e,row,prop,col,index1){
            if(this.pasteFlag) return;
            let maxLength = this.maxLength;
            if(col.maxLength){
                maxLength = col.maxLength;
            }
            // col.isInteger?value=value.replace(/^[0-9]*[1-9][0-9]*$/g,''):
            let rowprop = eval('row.'+prop );
            if(JSON.stringify(rowprop) == "null"){
                 rowprop="";
            }
            // e.target.selectionStart=e.target.selectionEnd=rowprop.length
            // e.target.type="number";
            let key = e.key;
            let ctrlKey=e.ctrlKey
            //限制长度
            if((rowprop+"").length> maxLength && key !== "Backspace"){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }

            //小数点前十五位判断
            let index = (rowprop+"").indexOf(".");
            let selectionStart=e.target.selectionStart;
            if(key === "Backspace"){
                selectionStart = selectionStart-1;
            }
            // this.inputFunc(0,row,prop,rowprop+"1");
            if((index == -1 && (rowprop+"").length > maxLength-3 && key !== "Backspace" && key !== ".")|| (index>-1&&index == maxLength-2&&index>=selectionStart && key !== "Backspace")){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //整数的时候 不能输入小数点
            // console.log(col.isInteger && key === '.',col.isInteger , key === '.',key )
            if(col.isInteger && (key === '.'|| key === 'Decimal')){
              
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            var reg = /^\d+$|^\d*\.\d+$/g;
            if (key === '.' || key === 'Decimal' ) {
                if(  rowprop == "" || this.tempkey =='.' || rowprop.toString().indexOf('.') !=-1){
                   e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                    return false;
                }else{
                    // this.tempkey = key;
                    this.inputQue(key,rowprop,selectionStart,e,index1,row,prop);
                    return true;
                }
            }else if(reg.test(key) || key === "Backspace" || (row.isFuShu && (key === 'Process' || key==='-'))){
                this.tempkey = "";
                this.inputQue(key,rowprop,selectionStart,e,index1,row,prop);
                return true;
            }
            // else{
            //     e.preventDefault ? e.preventDefault() : (e.returnValue = false);
            //     return false;
            // }
            this.inputQue(key,rowprop,selectionStart,e,index1,row,prop);
        },
        //输入监听 index下标 row 一行数据 prop 属性 e值 新数组
        inputFunc(index,row,prop,e){
            // console.log(index,row,prop,e)
            //防滚鼠标
            // e=e.replace(/[^\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');
            // e=e.replace(/[^\d.]/g,"");
            //.toFixed(2)
            //  if(!(/^(\d+\.?)?\d{0,2}$/.test(e))){
            //      console.log(/^(\d+\.?)?\d{0,2}$/.test(e),eval('row.'+prop));
            //     e = parseFloat(eval('row.'+prop));
            // }
			let that = this;
            eval('row.'+prop+"= e" );
            if(that.tableData !=undefined){
                var new_arr = JSON.parse(JSON.stringify(that.tableData));
                //排序出现值错乱得问题
                // console.log(row["defaultIndex"]);
                if(row["defaultIndex"]>=0){
                    new_arr[row.defaultIndex] = row;
                }else{
                    new_arr[index] = row;
                }
                //回掉事件
                that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
            }
        },
        //去除千分位
        delcommafy(num){
            if((num+"").trim()==""){
                return num;
            }
            num = num+"";
            num=num.replace(/,/gi,'');
            return num;
        },
        // 数字格式转换成千分位
        commafy(num){
            if((num+"").trim()=="" || isNaN(num) || num == null){
                return num;
            }
            num = num+"";
            if(/^.*\..*$/.test(num)){
            let pointIndex =num.lastIndexOf(".");
            let intPart = num.substring(0,pointIndex);
            let pointPart =num.substring(pointIndex+1,num.length);
            intPart = intPart +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(intPart)){
                intPart =intPart.replace(re,"$1,$2")
                }
            num = intPart+"."+pointPart;
            }else{
                num = num +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(num)){
                num =num.replace(re,"$1,$2")
                }
            }
            return num;
        },
        strGetVal(row,scope,index){
            if(this.formatterList && this.formatterList.indexOf(scope.column.property) != -1) {//日期格式化
				let dataStr = eval('scope.row.'+row );
				if( dataStr ){
					if ( row == "reviewTime" || row == "publishDatetime" ) {
						return moment(parseInt(dataStr)).format('YYYY-MM-DD HH:mm');
					}else{
						return moment(parseInt(dataStr)).format('YYYY-MM-DD');
					}
				}else{
					return "";
				}
			}else if(this.formatteColumn && this.formatteColumn.name.indexOf(scope.column.property) != -1){
				return  this.formatteColumn.list[eval('scope.row.'+row )-1];
			}else if(row == "sfSales"){
                if(scope.row.sfSales){
                    if(scope.row.sfSales == "0"){
                        return "未上市";
                    }else{
                        return "已上市";
                    }
                }
            }else if(row.slice(0,10) == "tongBiRise" || row.slice(0,10)=="huanBiRise"){
                if(row.slice(0,13) == "tongBiRisePur" || row.slice(0,13)=="huanBiRisePur"){
                    if(scope.row[row]){
                        return Number(scope.row[row]*100).toFixed(2)
                    }else{
                        return "/"
                    }
                }else{
                    if(scope.row[row]){
                        return scope.row[row]
                    }else{
                        return "/"
                    }
                }
            } else if (row == "reviewStatus") {
				let val = ""
				switch (scope.row.reviewStatus) {
					case "0":
						val = "未审核"
						break;
					case "1":
						val = "不通过"
						break;
					case "2":
						val = "已通过"
						break;
					default:
						val = "无"
						break;
				}
				return val	
			}else{
                if((this.focusIndex == index && this.editField.indexOf(this.focusProp) != -1) || row == 'materialCode'){
                    return  eval('scope.row.'+row);
                }else{
                    return this.commafy(eval('scope.row.'+row ))
                }
            }
        },
    }
};
</script>